<template>
    <v-row
            align="center"
            justify="center"
            class="grey lighten-5"
            style="height: 300px;"
    >
        <v-col cols="12">
            <v-card class="elevation-1 ma-4">
                <v-card-title>
                    <span class="headline">{{$t('counter.counterApp')}}</span>
                </v-card-title>
                <v-card-text>
                    <v-form ref="form">
                        <v-row align="center" >
                            <v-col cols="6" md="4">
                                <v-text-field
                                        v-model="counter.stationNumber"
                                        :label="$t('counter.stationNumber')"
                                        name="stationNumber"
                                        type="text"
                                        @change = "selectStationName"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="6" md="4">
                                <v-combobox
                                        v-model="counter.selectedStation"
                                        :items="station"
                                        item-text="name"
                                        small-chips
                                        hide-selected
                                        :label="$t('counter.stationName')"
                                        persistent-hint
                                        @change = "selectStationCode"
                                ></v-combobox>
                            </v-col>
                            <v-col cols="6" md="4">
                                <v-text-field type="text"
                                              :min = "0"
                                              v-model="counter.line"
                                              :label="$t('counter.line')"
                                              name="line"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="6" md="4">
                                <v-text-field
                                        v-model="counter.nameOfOperator"
                                        :label="$t('counter.nameOfOperator')"
                                        name="nameOfOperator"
                                        type="text"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="6" md="4">
                                <v-text-field
                                        v-model="counter.doorNumber"
                                        :label="$t('counter.doorNumber')"
                                        name="doorNumber "
                                        type="number"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="6" md="4">
                                <v-text-field type="number"
                                              :min = "0"
                                              v-model="counter.numberOfDoors"
                                              :label="$t('counter.numberOfDoors')"
                                              name="numberOfDoors"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="6" md="4">
                                <v-combobox
                                        v-model="counter.busType"
                                        :items="busType"
                                        small-chips
                                        hide-selected
                                        :label="$t('counter.busType')"
                                        persistent-hint
                                        type="button"
                                ></v-combobox>
                            </v-col>
                            <v-col cols="6" md="4">
                                <v-combobox
                                        v-model="counter.howFullIsTheBus"
                                        :items="howFullIsTheBus"
                                        small-chips
                                        hide-selected
                                        :label="$t('counter.howFullIsTheBus')"
                                        persistent-hint
                                ></v-combobox>
                            </v-col>
                            <v-col cols="6" md="4">
                                <v-dialog
                                        ref="dialog"
                                        v-model="time_stopped_at_station_modal"
                                        :return-value.sync="counter.timeStopped"
                                        persistent
                                        width="290px"
                                >
                                    <template v-slot:activator="{ on }">
                                        <v-text-field
                                                v-model="counter.timeStopped"
                                                :label="$t('counter.timeStopped')"
                                                prepend-icon="access_time"
                                                readonly
                                                v-on="on"
                                        ></v-text-field>
                                    </template>
                                    <v-time-picker
                                            v-if="time_stopped_at_station_modal"
                                            v-model="counter.timeStopped"
                                            full-width
                                            locale='he'
                                    >
                                        <v-spacer></v-spacer>
                                        <v-btn text color="primary" @click="time_stopped_at_station_modal = false">{{$t('Cancel')}}</v-btn>
                                        <v-btn text color="primary" @click="$refs.dialog.save(counter.timeStopped)">{{$t('Yes')}}</v-btn>
                                    </v-time-picker>
                                </v-dialog>
                            </v-col>
                            <v-col cols="6" md="4">
                                <v-combobox
                                        v-model="counter.stopped"
                                        :items="stoppedItems"
                                        small-chips
                                        hide-selected
                                        :label="$t('counter.stopped')"
                                        persistent-hint
                                        type="button"
                                ></v-combobox>
                            </v-col>
                            <v-col cols="6" md="4">
                                <v-text-field
                                        v-model="counter.licenseId"
                                        :label="$t('counter.liscenseId')"
                                        name="licenseId"
                                        type="text"
                                        :maxlength="8"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="6" md="4">
                                <v-text-field
                                        v-model="counter.comments"
                                        :label="$t('counter.comments')"
                                        name="comments"
                                        type="text"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" ></v-col>
                            <v-col cols="6">
                                <v-text-field class="centered-input" type="text"
                                              :label="$t('counter.numberOfPeopleWhoGotOn')"
                                              :min = "0"
                                              :height ="40"
																							step="1"
											                        oninput="this.value=this.value.replace(/[^0-9]/g,'');"
                                              outlined
                                              v-model="counter.numberOfPeopleWhoGotOn"
                                              append-icon="remove" @click:append="decrementOn"
                                              prepend-inner-icon="add" @click:prepend-inner="incrementOn">
                                </v-text-field>
                            </v-col>
                            <v-col cols="6">
                                <v-text-field class="centered-input" type="text"
                                              :label="$t('counter.numberOfPeopleWhoGotOff')"
                                              :min = "0"
																							step="1"
                                              :height ="40"
											                        oninput="this.value=this.value.replace(/[^0-9]/g,'');"
                                              outlined
                                              v-model="counter.numberOfPeopleWhoGotOff"
                                              append-icon="remove" @click:append="decrementOff"
                                              prepend-inner-icon="add" @click:prepend-inner="incrementOff">
                                </v-text-field>
                            </v-col>
                        </v-row>
                        <p class="text-start" style="color: rgb(251, 140, 0);margin-right: 10px;"> <span v-if="showLocationMissMatchMessage">{{$t('counter.gpsCoordinates.match')}}</span></p>
                        <v-card-actions ><div class="text-right">
                            <v-spacer></v-spacer>
                            <v-btn color="primary" @click="submit">{{$t('Submit')}}</v-btn>
                        </div>
                        </v-card-actions>
                    </v-form>
                </v-card-text>
                <v-bottom-sheet v-model="sheet">
                    <alert-msg :data="alertMessage" />
                </v-bottom-sheet>
            </v-card>
        </v-col>
    </v-row>
</template>
<script>
    import axios from "axios";
    import config from "../ayalconfig";
    import station from "../resources/station"
    const alertMsg = () => import("./AlertMessage");


    export default {
        components: {alertMsg},
        created() {
                //this.getLocation();
        },
        data() {
            return {
                message: "Click on Start Survey to Start your Survey",
                counter: {
                    stationName:'',
                    stationNumber:'',
                    licenseId:'',
                    comments:'',
                    numberOfDoors:'',
                    line:'',
                    nameOfOperator:'',
                    doorNumber:'',
                    numberOfPeopleWhoGotOn:0,
                    numberOfPeopleWhoGotOff:0,
                    selectedStation:'',
                    timeStopped:'',
                    stopped:'',
                    howFullIsTheBus:''
                },
                station: station.station,
                alertMessage:'',
                sheet: false,
                error: '',
                lat:'',
                lon:'',
                cons:'',
                nearestStation:[],
                gpsStation:'',
                busType:[this.$t('counter.busItem.minibus'), this.$t('counter.busItem.long'), 
							           this.$t('counter.busItem.city'), this.$t('counter.busItem.intercity'), this.$t('counter.busItem.3door'),this.$t('counter.busItem.4door'),this.$t('counter.busItem.5door')],
							howFullIsTheBus:[this.$t('howFullIsTheBus.empty'), this.$t('howFullIsTheBus.halfseated'), this.$t('howFullIsTheBus.fullseated'), this.$t('howFullIsTheBus.halfstanding'),this.$t('howFullIsTheBus.fullstanding')],
                time_stopped_at_station_modal : false,
                stoppedItems:[this.$t('Yes'),this.$t('No')],
                showLocationMissMatchMessage : false

            };
        },
        methods:{
            submit(){
                let self = this;
                axios({
                    method:'post',
                    url:`${config.baseUrl()}/counter`,
                    params: self.counter
                }).then(function (responseData) {
                    var response = responseData.data;
                    if(response.success) {
                        self.alertMessage = self.$t('counter.save.success');
                        self.sheet = true;
                        self.counter = {
                            stationNumber:self.counter.stationNumber,
                            selectedStation:self.counter.selectedStation,
                            numberOfPeopleWhoGotOn:0,
                            numberOfPeopleWhoGotOff:0,
                        }
                    }else {
                        self.alertMessage = self.$t('counter.save.failure');
                        self.sheet = true;
                    }
                }).catch(function (error) {
                        console.log(error);
                });
            },
            incrementOff () {
                this.counter.numberOfPeopleWhoGotOff = parseInt(this.counter.numberOfPeopleWhoGotOff,10) + 1
            },
            decrementOff () {
                var currentDecOff = parseInt(this.counter.numberOfPeopleWhoGotOff,10) - 1;
                this.counter.numberOfPeopleWhoGotOff = currentDecOff >=0 ? currentDecOff : 0;
            },
            incrementOn () {
                this.counter.numberOfPeopleWhoGotOn = parseInt(this.counter.numberOfPeopleWhoGotOn,10) + 1
            },
            decrementOn () {
                var currentDecOn = parseInt(this.counter.numberOfPeopleWhoGotOn,10) - 1;
                this.counter.numberOfPeopleWhoGotOn = currentDecOn >=0 ? currentDecOn : 0;
            },
            getLocation: function () {
                if(navigator.geolocation){
                    navigator.geolocation.getCurrentPosition(this.showPosition, this.positionError);
                }else{
                    this.error = "Geolocation is not supported.";
                }
            },
            showPosition:function (position) {
                var poslat = position.coords.latitude;
                var poslng = position.coords.longitude;
							  const radiusLimit = 0.5 //should be in km
                this.lat = poslat;
                this.lon = poslng;
                for (var i = 0; i < this.station.length; i++) {
                    // this location is within 0.1KM of the user
                    var dis = this.distance(poslat, poslng, this.station[i].lat, this.station[i].lon);
                    if (dis <= radiusLimit) {
                         this.nearestStation.push({'distance':dis, 'station':this.station[i]})
                    }
                }
                if (this.nearestStation.length > 0){
                    var cStation = this.nearestStation.reduce(function(prev, curr) {
                        return prev.distance < curr.distance ? prev : curr;
                    });
                    this.gpsStation = cStation.station;
                    this.counter.selectedStation = cStation.station
                }else{
                    // this.showLocationMissMatchMessage = true;
                }
            },
            distance:function (lat1, lon1, lat2, lon2) {
                var R = 6371; // Radius of the earth in km
                var dLat = this.deg2rad(lat2-lat1);  // deg2rad below
                var dLon = this.deg2rad(lon2-lon1);
                var a =
                    Math.sin(dLat/2) * Math.sin(dLat/2) +
                    Math.cos(this.deg2rad(lat1)) * Math.cos(this.deg2rad(lat2)) *
                    Math.sin(dLon/2) * Math.sin(dLon/2)
                ;
                var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
                var d = R * c; // Distance in km
                return d;
            },
            deg2rad: function (deg) {
                return deg * (Math.PI/180)
            },
            positionError:function (error) {
                switch ( error.code ) {
                    case error.PERMISSION_DENIED:
                        this.alertMessage = this.$t('counter.gpsCoordinates.userDenied');
                        this.sheet = true;
                        break;
                    case error.POSITION_UNAVAILABLE:
                        this.alertMessage = this.$t('counter.gpsCoordinates.unavailable');
                        this.sheet = true;
                        break;
                    case error.TIMEOUT:
                        this.alertMessage = this.$t('counter.gpsCoordinates.timeOut');
                        this.sheet = true;
                        break;
                    case error.UNKNOWN_ERR:
                        this.alertMessage = this.$t('counter.gpsCoordinates.unknownError');
                        this.sheet = true;
                        break;
                }
            },
            selectStationCode:function (e) {
                if (e){
                    this.validateStation(e.code);
                    this.counter.stationNumber = e.code;
                }
            },
            selectStationName:function (e) {
                if (e){
                    this.validateStation(e);
                    var isLocation = false;
                    for (var i = 0; i < this.station.length; i++) {
                       if (e === this.station[i].code){
                           this.counter.selectedStation = this.station[i];
                           isLocation = true;
                           break;
                       }
                    }
                    if (!isLocation){
                        this.counter.selectedStation = "";
                    }
                }
            },
            validateStation:function (code) {
                if (this.gpsStation){
                    if (this.gpsStation.code === code){
                        this.showLocationMissMatchMessage = false;
                    }else {
                        this.showLocationMissMatchMessage = true;
                    }
                }else{
                    this.showLocationMissMatchMessage = true;
                }
            }
        }

    }
</script>
<style>
    .centered-input input{
        text-align: center;
        font-size: 25px;
    }
</style>
